<template>
  <section class="slider-video">
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" xl="10" class="d-flex flex-column slider-video__wrapper">
          <svg class="shape-1" width="362" height="474" viewBox="0 0 362 474" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M107.578 71.9235C108.091 71.4013 108.555 71.0348 109.018 70.6682C115.088 65.2302 126.376 63.0002 126.376 63.0002L174.951 52.5989L233.072 40.1802C239.957 38.709 247.108 40.9663 251.901 46.1234L340.219 141.153L218.795 167.932C210.057 169.775 199.789 176.961 196.909 185.989C196.86 186.144 196.016 188.79 194.526 193.46L196.016 188.79C198.995 179.451 196.108 165.669 189.413 158.389L117.843 80.5137C117.312 80.0016 116.939 79.5397 116.674 79.2837C116.144 78.7716 115.564 78.4151 115.034 77.903C114.454 77.5466 113.874 77.1901 113.294 76.8337L113.137 76.7835C112.665 76.6329 112.085 76.2764 111.563 76.2815C111.091 76.1309 110.461 75.9301 109.939 75.9351C109.782 75.8849 109.575 75.9904 109.418 75.9401C109.053 75.9954 108.738 75.895 108.374 75.9503C108.167 76.0557 107.803 76.111 107.645 76.0608C107.281 76.116 106.916 76.1713 106.502 76.3822C106.295 76.4876 106.088 76.5931 105.724 76.6483C105.517 76.7538 105.31 76.8592 105.103 76.9647C104.639 77.3313 104.175 77.6978 103.712 78.0644C103.455 78.3255 103.198 78.5866 102.892 79.0033C102.635 79.2644 102.586 79.4201 102.329 79.6812L102.279 79.8368C101.923 80.4092 101.518 81.1373 101.112 81.8654C102.925 77.8134 105.06 74.3789 107.578 71.9235Z" fill="#BDD4EF"/>
            <path d="M101.773 81.4173C101.624 81.8853 101.317 82.3032 101.118 82.9272C101.524 82.1973 101.93 81.4673 102.286 80.8934L102.336 80.7374C102.592 80.4754 102.642 80.3194 102.898 80.0575C103.155 79.7955 103.461 79.3776 103.718 79.1156C104.181 78.7477 104.644 78.3799 105.107 78.012C105.314 77.9061 105.521 77.8001 105.727 77.6942C105.934 77.5882 106.141 77.4823 106.505 77.4264C106.868 77.3705 107.282 77.1587 107.645 77.1028C107.852 76.9969 108.216 76.941 108.373 76.9911C108.736 76.9352 109.1 76.8793 109.414 76.9794C109.571 77.0295 109.778 76.9236 109.935 76.9736C110.455 76.9678 110.926 77.118 111.554 77.3183C112.025 77.4685 112.496 77.6187 113.124 77.8189L113.281 77.869C113.859 78.2253 114.487 78.4255 115.015 78.9378C115.593 79.294 116.122 79.8063 116.65 80.3186C116.914 80.5747 117.335 80.8809 117.814 81.5492L189.114 159.463C195.783 166.746 198.693 180.393 195.658 189.909L194.165 194.59L120.921 424.228C117.935 433.588 110.256 435.435 103.429 428.102L31.9723 350.138C25.3029 342.855 22.2355 329.157 25.2708 319.641L100.058 85.1672C100.663 83.8132 101.218 82.6152 101.773 81.4173Z" fill="#13588A"/>
            <path d="M121.185 424C121.185 424 196.927 187.075 197.069 186.087C199.961 177.02 210.212 169.785 218.924 167.914L340.002 140.745L318.713 207.492L309.39 236.878L269.83 361.568L254.111 411.116C254.111 411.116 131.729 438.041 130.689 438.054C130.689 438.054 118.749 439.757 106.346 430.462C112.594 434.693 118.592 432.129 121.185 424Z" fill="#007CC2"/>
          </svg>
          <svg class="shape-2" width="438" height="386" viewBox="0 0 438 386" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M293.793 185.587C305.831 188.74 317.86 189.182 329.749 190.282C355.344 192.645 380.94 195.493 406.723 195.002C411.942 194.898 416.938 195.822 421.627 198.287C432.596 204.04 438.709 216.115 436.881 228.561C435.08 240.692 425.386 250.655 413.11 252.524C408.886 253.167 404.574 253.096 400.291 253.197C375.359 253.799 350.642 250.919 325.844 249.038C324.17 248.902 322.439 248.879 320.795 249.113C320.426 249.172 319.751 250.829 319.979 251.085C322.001 253.274 324.108 255.407 326.356 257.424C339.787 269.474 353.275 281.465 366.706 293.515C369.268 295.816 371.8 298.175 373.994 300.792C382.483 311.033 383.241 324.753 376.103 335.649C369.36 345.943 356.782 350.724 344.546 347.657C338.583 346.166 333.523 343.046 328.97 338.954C306.603 318.834 284.293 298.656 261.841 278.622C254.784 272.342 247.332 266.52 239.992 260.583C238.74 259.56 237.119 258.14 235.479 259.686C234.716 260.402 234.38 261.915 234.356 263.056C234.172 275.125 233.959 287.194 234.031 299.291C234.137 321.486 229.817 342.985 223.878 364.203C222.842 367.887 221.408 371.63 219.377 374.832C209.899 389.645 188.907 389.376 179.55 374.488C176.755 370.048 175.064 365.175 174.903 359.869C174.682 353.393 174.403 346.947 174.551 340.47C174.993 321.068 175.662 301.665 176.217 282.263C176.292 279.267 176.252 276.243 176.1 273.219C176.009 271.451 173.792 270.261 172.292 271.179C169.376 272.987 166.518 274.908 163.688 276.83C146.003 289.017 128.203 301.034 109.69 311.913C104.51 314.955 99.2726 317.941 93.8065 320.357C82.3929 325.418 70.4512 325.518 58.4992 322.735C54.837 321.893 51.1432 320.137 48.0719 317.951C34.8199 308.497 35.6041 289.608 49.4165 281.057C53.096 278.79 57.1473 277.378 61.3992 276.535C66.1047 275.606 70.3526 273.594 74.2002 270.727C94.1171 255.792 114.034 240.829 133.922 225.809C134.488 225.379 134.569 224.324 134.879 223.552C133.31 221.047 130.474 221.285 128.146 220.837C99.9034 215.602 71.6611 210.509 43.3907 205.474C39.6157 204.803 35.6731 204.902 31.898 204.231C27.2716 203.448 22.5035 202.723 18.1578 201.113C7.5633 197.156 0.975773 187.279 0.851512 176.21C0.725133 164.542 7.58289 154.589 18.7727 150.413C24.0419 148.454 29.5423 147.721 35.1576 147.388C48.9973 146.569 62.5075 148.832 75.9903 151.352C86.8901 153.396 97.818 155.354 108.689 157.341C109.612 153.544 107.082 152.155 105.403 150.42C89.5165 134.072 73.6305 117.723 57.6596 101.461C50.4 94.04 44.1305 85.8741 38.7946 76.9631C35.6272 71.6678 34.0184 65.939 34.2234 59.7187C34.7835 41.6573 52.7319 31.5513 68.2808 40.7685C72.3172 43.1507 75.9308 46.3048 79.431 49.4592C101.513 69.2379 123.595 89.0736 145.536 109.024C156.378 118.857 167.588 128.204 179.192 137.092C180.216 137.859 181.268 138.597 182.377 139.278C184.794 140.782 186.748 139.976 186.852 137.351C186.982 133.898 186.941 130.446 186.957 126.994C186.867 101.546 186.919 76.0967 186.63 50.6491C186.543 41.9192 187.619 33.4135 189.547 25.0189C192.005 14.3115 198.075 6.15899 208.642 2.32713C228.133 -4.76018 249.204 10.0579 247.008 30.7499C243.548 63.0865 246.102 95.3733 245.252 127.672C245.203 129.841 245.154 131.98 245.275 134.148C245.484 137.058 244.107 140.885 246.808 142.559C249.935 144.517 252.135 140.857 254.313 139.138C275.246 122.659 296.036 106.009 315.999 88.3073C320.835 84.0393 325.642 79.7428 330.592 75.6169C333.222 73.4394 335.994 71.2613 338.995 69.7101C350.972 63.5338 364.481 65.3975 373.59 74.2666C382.47 82.9082 385.329 97.2487 380.577 108.934C377.371 116.791 372.317 123.485 364.927 127.192C355.526 131.875 347.977 138.835 339.972 145.254C325.546 156.802 311.263 168.55 296.951 180.241C295.678 181.301 294.064 182.191 293.792 185.53L293.793 185.587Z" fill="#FF4337"/>
          </svg>
          <h3 v-if="payload.title" class="mt-0 slider-video__title">{{payload.title}}</h3>
          <div class="slider-video__container">
            <div class="slider-video__container-swiper swiper">
              <div class="slider-video__box swiper-wrapper d-flex" v-if="payload.slider">
                <div class="slider-video__card swiper-slide" v-for="(slide, index) in payload.slider" :key="index">
                  <div class="slider-video__card-video" v-if="slide.url_video">
                    <iframe width="560" height="315" :src="slide.url_video" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                  <h3 class="slider-video__card-title" v-if="slide.title">{{slide.title}}</h3>
                  <p class="slider-video__card-text" v-if="slide.text">{{slide.text}}</p>
                </div>
              </div>
              <div class="slider-video__nav">
                <div class="d-flex">
                  <div class="slider-video__nav-arrows">
                    <svg class="slider-video__nav-left" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 8.42871L12 16.4287L20 24.4287" stroke="#111111" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg class="slider-video__nav-right" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8.42871L20 16.4287L12 24.4287" stroke="#111111" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Swiper from "swiper";
import 'swiper/swiper-bundle.min.css';
import {Navigation} from "swiper/modules";

export default {
  name: "SliderVideo",
  props: ['payload'],
  methods: {},
  mounted() {
    this.swiper = new Swiper('.slider-video__container-swiper', {
      modules: [Navigation],
      slidesPerView: 1,
      loop: false,
      spaceBetween: 40,
      centeredSlides: true,
      breakpoints: {
        576: {
          centeredSlides: false,
          slidesPerView: 'auto'
        },
      },
      navigation: {
        nextEl: '.slider-video__nav-right',
        prevEl: '.slider-video__nav-left',
      }
    });
  },
}
</script>

<style lang="scss" scoped>
.slider-video{
  position: relative;
  background: $main-bg;
  color: $main-color;
  padding-top: 70px;
  padding-bottom: 70px;
  z-index: 2;

  .row {
    @include media-breakpoint-down(sm){
      margin: 0;
    }
  }

  &__wrapper {
    position: relative;
    padding: 64px;
    background: $main-blue;
    border-radius: 20px;

    @include media-breakpoint-down(sm){
      padding: 32px 20px;
    }
  }

  .shape-1 {
    position: absolute;
    top: -33%;
    right: 1%;
    z-index: -1;

    @include media-breakpoint-down(sm){
      display: none;
    }
  }

  .shape-2 {
    position: absolute;
    top: -20%;
    left: -13%;
    z-index: -1;

    @include media-breakpoint-down(sm){
      width: 100%;
    }
  }

  &__title {
    font-size: 1.75em;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 40px;

    @include media-breakpoint-down(lg){
      padding: 20px;
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    background: $white;
    padding: 16px;
    border-radius: 16px;
    width: 352px;

    &-title {
      font-size: 1.125em;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      margin-bottom: 8px;
    }

    &-text {
      font-size: 1em;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 0;
    }

    &-video {
      width: 320px;
      height: 198px;
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      margin-bottom: 16px;

      @media screen and (max-width: 580px) {
        width: 100%;
        height: 186px;
      }

      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__nav {
    margin-top: 48px;
    display: flex;
    justify-content: flex-end;
  }

  .slider-video__nav-left,
  .slider-video__nav-right {

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
